var localStorageKey = 'thisplacematters.places';

export function writeToStorage(widgetId, key, value) {
  return localStorage.setItem([localStorageKey, widgetId, key].join('.'), value);
}

export function readFromStorage(widgetId, key) {
  return localStorage.getItem([localStorageKey, widgetId, key].join('.'));
}



/** WEBPACK FOOTER **
 ** ./lib/storage.js
 **/